<template>
  <!-- pantalla cargando -->
  <div v-if="datosHistorial == null">
    <Loader></Loader>
  </div>
  <!-- pantalla historial vacio -->
  <div v-if="estaHistorialVacio">
    <h4>Historial Vacio</h4>
  </div>
  <!-- pantalla historial -->
  <div
    class="containerHistorial bounceAnimation"
    v-else-if="datosHistorial && !cargando"
  >
    <table class="tftable">
      <tr>
        <th>Moneda</th>
        <th>Cantidad</th>
        <th>Dinero</th>
        <th>Resultado</th>
      </tr>
      <tr
        v-for="transaccion in cartera"
        :key="transaccion.id"
        :class="obtenerClassPorSimbolo(transaccion.simbolo)"
      >
        <td>{{ transaccion.simbolo }}</td>
        <td>
          {{ transaccion.monto }}
        </td>
        <td>$ {{ transaccion.montoEnDinero }}</td>
        <td>
          {{ transaccion.resultado < 0 ? "-" : "+" }}
          $
          {{
            transaccion.resultado < 0
              ? transaccion.resultado.toFixed(2) * -1
              : transaccion.resultado.toFixed(2)
          }}
        </td>
      </tr>
      <tr>
        <td>TOTAL</td>
        <td></td>
        <!-- calcular la suma de todas las criptos-->
        <td>$ {{ calcularSumaTotal() }}</td>
        <td></td>
      </tr>
    </table>
  </div>
</template>
<script>
/* eslint-disable */
import axios from "axios";
import Loader from "@/components/Loader.vue";
import { mapGetters } from "vuex";
export default {
  name: "EstadoActualComponent",
  data() {
    return {
      datosHistorial: null,
      estaHistorialVacio: false,
      cartera: [
        { id: 0, simbolo: "BTC", monto: 0, montoEnDinero: 0, precioVentaActual: 0, resultado: 0},
        { id: 1, simbolo: "DAI", monto: 0, montoEnDinero: 0, precioVentaActual: 0, resultado: 0},
        { id: 3, simbolo: "ETH", monto: 0, montoEnDinero: 0, precioVentaActual: 0, resultado: 0},
        { id: 4, simbolo: "USDT", monto: 0, montoEnDinero: 0, precioVentaActual: 0, resultado: 0},
      ],
      cargando: true,
    };
  },
  components: {
    Loader,
  },
  async mounted() {
    if (this.$store.state.username == "") {
      this.$router.push("/");
    } else {
      await this.ObtenerHistorial();
      await this.ejecutarMetodosConsecutivos();
      this.cargando = false;
    }
  },
  computed: {
    ...mapGetters(["getHistorial"]),
  },
  methods: {
    async ejecutarMetodosConsecutivos() {
      await this.CargarMontoYPrecioEnDinero();
      this.calcularSumaTotal();
      await this.calcularResultado();
      this.cargando = false;
    },
    CargarMontos(){
      this.datosHistorial.forEach(transaccion => {
        if(transaccion.action == "sale"){
          this.cartera.find(
            i => i.simbolo === transaccion.crypto_code
          ).monto -= parseFloat(transaccion.crypto_amount);
        }
        else if(transaccion.action == "purchase"){
          this.cartera.find(
            i => i.simbolo === transaccion.crypto_code
          ).monto += parseFloat(transaccion.crypto_amount);
        }
      });
    },
    async CargarMontoYPrecioEnDinero() {
      this.cartera.forEach(e => {
        axios.get(`https://criptoya.com/api/argenbtc/${e.simbolo}/ars`)
          .then(response => {
            let precio = response.data.totalBid;
            //cargo precio de venta
            e.precioVentaActual = parseFloat(response.data.totalBid).toFixed(2);
            //cargo monto
            e.montoEnDinero = parseFloat(precio * e.monto).toFixed(2);
          })
          .catch(error => {
            console.error('Error al obtener los datos:', error);
          });
      });
    },
    async ObtenerHistorial() {
      this.datosHistorial = null;
      this.estaHistorialVacio = false;
      await this.$store.dispatch("ObtenerHistorial")
      .then(() => {
        if(this.getHistorial.length < 1)
          this.estaHistorialVacio = true;

        this.datosHistorial = this.getHistorial;
        this.CargarMontos();
      });
    },
    calcularSumaTotal() {
      let sumaTotal = 0;

      for (let i = 0; i < this.cartera.length; i++) {
        sumaTotal += parseFloat(this.cartera[i].montoEnDinero);
      }
      return sumaTotal;
    },
    async calcularResultado() {
      let montoActual;
      let precioVentaActual;
      
      this.datosHistorial.forEach(transaccion => {
        //Obtengo el monto actual de la cripto a evaluar
        montoActual = this.cartera.find(i => i.simbolo === transaccion.crypto_code).monto;

        //Si la cantidad es 0 no tengo precio para comparar
        if(montoActual === 0){
          if(transaccion.action == "sale"){
            this.cartera.find(
              i => i.simbolo === transaccion.crypto_code
            ).resultado += parseFloat(transaccion.money);
          }
          else if(transaccion.action == "purchase"){
            this.cartera.find(
              i => i.simbolo === transaccion.crypto_code
            ).resultado -= parseFloat(transaccion.money);
          }
        }
        else {
          let cantidadVendida = 0;
          if(transaccion.action == "sale"){
            cantidadVendida = transaccion.money;
          }
          if(transaccion.action == "purchase") {
            //Obtengo el precio de venta actual
            axios.get(`https://criptoya.com/api/argenbtc/${transaccion.crypto_code}/ars`)
              .then(response => {
                precioVentaActual = parseFloat(response.data.totalBid).toFixed(2);
                //calculo el precio actual
                let precioActual = montoActual * precioVentaActual;
                //obtengo el precio pagado de la transaccion y le resto x el precio vendido
                let precioPagado = transaccion.money - cantidadVendida;
                //cargo el resultado en el array
                this.cartera.find(
                  i => i.simbolo === transaccion.crypto_code
                ).resultado = parseFloat(precioActual - precioPagado);
              })
              .catch(error => {
                console.error('Error al obtener los datos:', error);
              });
          }
        }
      });
    },

    obtenerClassPorSimbolo(simbolo) {
      if (simbolo === 'DAI') {
        return 'fondo-DAI';
      } else if (simbolo === 'BTC') {
        return 'fondo-BTC';
      } else if (simbolo === 'ETH'){
        return 'fondo-ETH';
      } else if (simbolo === 'USDT'){
        return 'fondo-USDT';
      } else '';
    },
  }
}
</script>

<style scoped>
.containerHistorial {
  min-width: 800px;
  min-height: 85px;
  max-height: 600px;
  background-color: #fff;
  padding: 20px;
  border-radius: 10px;
  box-shadow: 0px 0px 15px rgba(0, 0, 0, 0.5);
  text-align: center;
  display: flex;
  justify-content: center;
}
.tftable {
  font-size:12px;
  color:#333333;
  width:100%;
  border-width: 1px;
  border-color: #729ea5;
  border-collapse: collapse;
}
.tftable th {
  font-size:14px;
  background-color:#acc8cc;
  border-width: 1px;
  padding: 8px;
  border-style: solid;
  border-color: #59a9ff;
  text-align:center;
}
.tftable td {
  font-size:14px;
  border-width: 1px;
  padding: 8px;
  border-style: solid;
  border-color: #fff;
}
.tftable tr:hover {
  background-color:#ffffff;
}

.fondo-DAI {
  background-color: #ccffcc;
}
.fondo-BTC {
  background-color: #b3e0ff;
}
.fondo-ETH {
  background-color: #f2b3ff;
}
.fondo-USDT {
  background-color: #e6ffb3;
}
</style>